//TeamMember component to display individual team member cards

import React from 'react';

// This is the component that renders a single team member card.
const TeamMember = ({ member }) => {

    return (
        // The outer div uses the Bootstrap grid classes for layout
        <div className="col-md-4 col-sm-6">
            <div className="sf-team">
                <div className="thumb">
                    {/* Preserve <a> and <img> tags, using the member data for src and alt */}
                    <a href="#"><img src={member.image} alt={member.name} /></a>
                </div>
                <div className="text-col">
                    <h3>{member.name}</h3>
                    <p>{member.role}</p>
                    <ul className="team-social">
                        {(member.social || []).map((link, index) => (
                            <li key={index}>
                                <a href={link.href}>
                                    <i className={link.icon} aria-hidden="true"></i>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default TeamMember;